import { useEffect } from 'react'
import { gql, useLazyQuery, useQuery } from '@apollo/client'
import requestFragment from 'graphql/fragments/requestFragment'
import { currentMarketIdVar } from 'graphql/reactive'

import useEffectOnce from './useEffectOnce'
import useImportOnDemandVideo from './useImportOnDemandVideo'

export const GET_REQUEST_BY_SHORTID = gql`
  query GetPublicRequestByShortId($marketId: ID!, $shortId: ID) {
    market(id: $marketId) {
      id
      ...requestFragment
    }
  }
  ${requestFragment}
`

export default function useRequest(shortId) {
  const marketId = currentMarketIdVar()

  const {
    data = {},
    error,
    loading,
  } = useQuery(GET_REQUEST_BY_SHORTID, {
    variables: { marketId, shortId },
  })

  const [pollRequest, { stopPolling, pollingData = {} }] = useLazyQuery(
    GET_REQUEST_BY_SHORTID,
    {
      variables: { marketId, shortId },
      pollInterval: 3000,
      context: {
        noCache: true,
      },
    },
  )

  const [importOnDemandVideo] = useImportOnDemandVideo()

  const request = pollingData?.market?.request || data?.market?.request

  useEffectOnce(() => {
    if (request && request.video?.available === false) {
      importOnDemandVideo(request.video.id)
    }
  })

  useEffect(() => {
    if (
      request &&
      (request.video?.ready === false || request.video?.available === false)
    ) {
      pollRequest()
    }
    if (
      request &&
      request.video?.ready === true &&
      request.video?.available === true &&
      stopPolling
    )
      stopPolling()
  }, [request, pollRequest, stopPolling])

  return { request, loading, error }
}
